module.exports = __webpack_public_path__ + "img/control-radio-null.9b202452.svg";